import * as React from 'react';

export default function useCombinedRefs<RefType = HTMLInputElement>(
  ...refs: (React.ForwardedRef<unknown> | undefined)[]
) {
  const [targetRef, setTargetRef] = React.useState<RefType>();

  React.useEffect(() => {
    refs.forEach((ref) => {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(targetRef);
      } else {
        // eslint-disable-next-line no-param-reassign
        ref.current = targetRef;
      }
    });
  }, [refs, targetRef]);

  return setTargetRef;
}
